import {ref} from 'vue';
import {useAuthStore} from '@/stores/auth.store';

export type VersaoMenu = 'classico' | 'novo';

const versao = ref<VersaoMenu>('novo');
let publicIdCarregado: string | null = null;

function lerVersao(chave: string): VersaoMenu {
    const bruto = localStorage.getItem(chave);
    return bruto === 'classico' ? 'classico' : 'novo';
}

function garantirCarregado() {
    const publicId = useAuthStore().userStore.publicId;

    if (publicId === publicIdCarregado) {
        return publicId;
    }

    publicIdCarregado = publicId;
    versao.value = lerVersao(`menuVersao-${publicId}`);

    return publicId;
}

export function useMenuVersao() {
    const publicId = garantirCarregado();

    const definirVersao = (novaVersao: VersaoMenu) => {
        versao.value = novaVersao;
        localStorage.setItem(`menuVersao-${publicId}`, novaVersao);
    };

    const alternarVersao = () => {
        definirVersao(versao.value === 'classico' ? 'novo' : 'classico');
    };

    return {
        versao,
        definirVersao,
        alternarVersao
    };
}
